import { render, staticRenderFns } from "./PurchaseDone.vue?vue&type=template&id=3746147c&scoped=true&"
import script from "./PurchaseDone.vue?vue&type=script&lang=js&"
export * from "./PurchaseDone.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDone.vue?vue&type=style&index=0&id=3746147c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3746147c",
  null
  
)

export default component.exports